import { Component, inject } from '@angular/core';
import { DarkModeService } from '../../../../shared/services/dark-mode.service';
import { LanguageService } from '../../../../shared/services/language.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
})
export class ThemeToggleComponent {
  readonly darkMode = inject(DarkModeService);
  readonly language = inject(LanguageService);

  setLang(lang: 'es' | 'en') {
    this.language.setLang(lang);
  }

  interfaceDockLabel(): string {
    return this.language.t('landing.preferences.interface');
  }

  languageLabel(): string {
    return this.language.t('landing.preferences.language');
  }

  themeToggleLabel(): string {
    const isSpanish = this.language.currentLang() === 'es';
    if (this.darkMode.isDark()) {
      return isSpanish ? 'Cambiar a modo claro' : 'Switch to light mode';
    }
    return isSpanish ? 'Cambiar a modo oscuro' : 'Switch to dark mode';
  }
}
